import {
  CustomLabel,
  FlexContainer,
  TableContainer,
  ITableHeaders,
  ToastService,
  CollapsiblePanel,
} from "@mindmemobile/mm-shared-global";
import DeleteIcon from "../../../../../../images/products/trash-blue.svg";
import RenameIcon from "../../../../../../images/common/rename-icon-blue.svg";
import React, { useState } from "react";
import RenameCategoryPopup from "./RenameCategoryPopUp";
import DeleteCategoryPopup from "./DeleteCategoryPopUp";
import {
  CategoriesModel,
  CountryWithStateModel,
  GeneralSettingsModel,
} from "../../../shared/models";
import { VariantWrapper } from "../../../shared/styles";
import { TableGrid } from "../../../shared/components";
import { RolesAndPermissionStore } from "../../../shared/store";

type Iprops = {
  generalSettings: GeneralSettingsModel;
  rolesAndPermissionStore: RolesAndPermissionStore;
  countriesWithState: CountryWithStateModel[];
  handleChange: (settings: GeneralSettingsModel) => void;
};

const Categories: React.FC<Iprops> = ({
  generalSettings,
  handleChange,
  rolesAndPermissionStore,
  countriesWithState,
}) => {
  const [selectedCategory, setSelectedCategory] =
    useState<CategoriesModel | null>(null);
  const [showRenamePopup, setShowRenamePopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  const onClickRename = (category: CategoriesModel) => {
    setSelectedCategory(category);
    setShowRenamePopup(true);
  };

  const onClickDelete = (category: CategoriesModel) => {
    setSelectedCategory(category);
    setShowDeletePopup(true);
  };

  const handleRename = (updatedCategory: CategoriesModel) => {
    const categoryIndex = generalSettings.categories.findIndex(
      (cat) => cat.id === updatedCategory.id
    );
    const clonedData = generalSettings.categories.map(
      (cat) => new CategoriesModel(cat)
    );
    if (categoryIndex > -1) {
      clonedData[categoryIndex] = updatedCategory;
      handleChange(
        new GeneralSettingsModel({ ...generalSettings, categories: clonedData })
      );
      ToastService.showSuccess("Category renamed successfully");
    } else {
      ToastService.showError("Failed to rename category");
    }
    setShowRenamePopup(false);
    setSelectedCategory(null);
  };

  const handleDelete = (
    selectedCategory: CategoriesModel,
    newCategoryId?: string
  ) => {
    if (newCategoryId) {
      console.log("");
    }
    if (selectedCategory) {
      const updatedCategories = generalSettings.categories.filter(
        (category) => category.id !== selectedCategory.id
      );
      handleChange(
        new GeneralSettingsModel({
          ...generalSettings,
          categories: updatedCategories,
        })
      );
      ToastService.showSuccess("Category deleted successfully");
    } else {
      ToastService.showError("Failed to delete category");
    }
    setShowDeletePopup(false);
    setSelectedCategory(null);
  };

  function columns() {
    const columns: ITableHeaders<CategoriesModel>[] = [
      {
        dataKey: "name",
        title: "Category Name",
        className: "table-col-40",
        cellClassName: "table-col-40",
        onCellRender: (data: CategoriesModel) => {
          return <CustomLabel>{data.name}</CustomLabel>;
        },
      },
      {
        dataKey: "usedInItems",
        title: "Used In Items",
        cellColor: "#556bb8",
        className: "table-col-20 text-center",
        cellClassName: "table-col-20 text-center",
        onCellRender: (data: CategoriesModel) => {
          return <CustomLabel>{data.usedInItems}</CustomLabel>;
        },
      },
      {
        dataKey: "usedInItems",
        title: "Actions",
        className: "table-col-20 text-center",
        cellClassName: "table-col-20 text-center",
        onCellClick: (e) => {
          e.stopPropagation();
        },
        onCellRender: (data: CategoriesModel) => {
          return (
            <FlexContainer
              alignItems="center"
              justifyContent="center"
              spacing={10}
            >
              <img
                src={RenameIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!rolesAndPermissionStore.hasManagePermission("Rename"))
                    return;
                  onClickRename(data);
                }}
                className="img-15 clickable"
                alt="rename-icon"
              />
              <img
                src={DeleteIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!rolesAndPermissionStore.hasManagePermission("Delete"))
                    return;
                  onClickDelete(data);
                }}
                className="img-15 clickable"
                alt="delete-icon"
              />
            </FlexContainer>
          );
        },
      },
    ];
    return columns;
  }

  if (generalSettings.categories.length < 1) {
    return null;
  }
  return (
    <VariantWrapper className="category-block">
      <CollapsiblePanel
        title="Categories"
        className="payment-detail-header"
        collapsibleClassName="full-width"
        isOpened={false}
      >
        <TableContainer className="ps-left-margin categories-table">
          <TableGrid
            totalItemCount={generalSettings.categories.length}
            cellSpacing={20}
            data={generalSettings.categories || []}
            headers={columns()}
            className="recent-customer-table table item-variant-table variant-table-chckbx"
            countriesWithState={countriesWithState}
          />
        </TableContainer>
        {showRenamePopup && selectedCategory && (
          <RenameCategoryPopup
            category={selectedCategory}
            onClose={() => setShowRenamePopup(false)}
            onRename={handleRename}
          />
        )}
        {showDeletePopup && selectedCategory && (
          <DeleteCategoryPopup
            category={selectedCategory}
            onClose={() => setShowDeletePopup(false)}
            onDelete={handleDelete}
            categories={generalSettings.categories}
          />
        )}
      </CollapsiblePanel>
    </VariantWrapper>
  );
};

export default Categories;
